export function extractFileName(value) {
  if (!value) return '';
  try {
    const segments = value.split('/').filter(Boolean);
    if (segments.length === 0) return value;
    const lastSegment = segments[segments.length - 1];
    return decodeURIComponent(lastSegment);
  } catch (_unused) {
    return value;
  }
}